import { BUILD_VERSION, PACKAGE_VERSION } from '../data/environment'

/** Footer line: "VERSION: x | BUILD: y" (the tap target for the debug panel). */
export const VersionAndBuildInfo = () => (
  <div
    style={{
      opacity: 0.7,
      fontSize: '0.85em',
      lineHeight: '20px',
      marginBottom: '4px',
    }}
  >
    <span
      style={{
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '0.75em',
      }}
    >
      version:
    </span>{' '}
    {PACKAGE_VERSION}
    <span
      style={{
        padding: '0 7px',
        fontSize: '0.65em',
        verticalAlign: 'top',
        lineHeight: '20px',
      }}
    >
      |
    </span>
    <span
      style={{
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '0.75em',
      }}
    >
      build:
    </span>{' '}
    {BUILD_VERSION}
  </div>
)
